import { IUserGroup, IUserGroupCreate, IUserGroupUpdate } from '../../resource/user-group/user-group.types';
import { IApiRequestConfig } from '../api.types';

export const getUserGroupsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getUserGroups',
  uri: 'json',
  action: 'groups?includeUsers=true',
  method: 'get',
  v2: true,
});

export const createUserGroupApi = (userGroup: IUserGroupCreate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createUserGroup',
  uri: 'json',
  action: 'saveUserGroup',
  method: 'post',
  data: userGroup,
});

export const updateUserGroupApi = (
  id: IUserGroup['id'],
  name: IUserGroupUpdate['name'],
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateUserGroup',
  uri: 'json',
  action: `groups/${id}`,
  method: 'patch',
  data: {
    name,
  },
  v2: true,
});

export const deleteUserGroupApi = (id: IUserGroup['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteUserGroup',
  uri: 'json',
  action: `groups/${id}`,
  method: 'delete',
  v2: true,
});
